// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wLGk","title":"Info_title___qP7w","links":"Info_links__1Ajhp","link":"Info_link__GqPtP","logo":"Info_logo__2cQ2b"};